import React from 'react';
import { motion } from 'framer-motion';
import video2 from "../../assets/institutepage.mp4";
import CartButton from '../CartButton';

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
        },
    },
};

const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
};

const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, delay: 0.5 } }
};

const videoVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 1 } }
};

function InstituteHero() {
    return (
        <section>
            <div className="pt-12 bg-gray-50 sm:pt-16 mb-4">
                <div className="px-3 mx-auto max-w-7xl sm:px-6 lg:px-6">
                    <motion.div
                        className="text-center"
                        initial="hidden"
                        animate="visible"
                        variants={containerVariants}
                    >
                        <motion.p
                            className="max-w-6xl mx-auto mb-4 text-2xl font-bold leading-tight text-gray-900 sm:leading-tight sm:text-4xl lg:text-5xl lg:leading-tight"
                            variants={textVariants}
                        >
                            We offer our customers to empower their Educational Institution
                        </motion.p>
                        <motion.h1
                            className="max-w-4xl mx-auto px-3 md:text-lg lg:text-lg xl:text-lg text-sm text-gray-600 font-inter"
                            variants={textVariants}
                        >
                            Our platform is designed to streamline the processes of course creation, batch management, student registration, content management, live classes, assessments, and much more.
                        </motion.h1>
                        <motion.div
                            className="px-8 sm:items-start sm:justify-center sm:px-0 sm:space-x-5 sm:flex mt-9"
                            variants={buttonVariants}
                        >
                            <a href="/" title=""
                                className="mb-3 sm:mb-0 inline-flex items-center justify-center w-full px-8 py-3 text-lg font-bold text-gray-700 transition-all bg-yellow-400 border-2 border-transparent sm:w-auto rounded-xl hover:bg-blue-600 focus:outline-none focus:ring-blue-700 hover:text-white hover:transition hover:duration-150 hover:ease-in-out ease-in-out duration-150"
                                role="button">
                                Book a demo Session
                            </a>
                        </motion.div>
                    </motion.div>
                </div>
                <div className="bg-white">
                    <motion.div
                        className="relative mx-auto mt-4 md:mt-8"
                        initial="hidden"
                        animate="visible"
                        variants={videoVariants}
                    >
                        <div className="lg:max-w-4xl w-auto lg:mx-auto">
                            <video
                                className=""
                                autoPlay
                                muted
                                loop
                                playsInline
                                src={video2}
                                type="video/mp4"
                            />
                        </div>
                    </motion.div>
                </div>
            </div>
            <CartButton />
        </section>
    )
}

export default InstituteHero;
